import Api_Usermanagement from '../../api-usermanagement'
const api = new Api_Usermanagement().init()

const editLog = (id, data) => {
    return api.put(
      `/log/sales-order/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
}

const addLog = (data) => {
  return api.post(
    `/log/sales-order`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

export { editLog, addLog }